import { Alert, Typography, Stack } from "@mui/material";
import { useQuotaAlertsState } from "./State/QuotaAlertsState";

export const QuotaAlerts = () => {
  const state = useQuotaAlertsState();

  return (
    <Stack direction="column" gap={1}>
      {state.shouldShowEmailError && (
        <Alert
          severity="error"
          onClose={() => state.setHasUserClosedEmailAlert(true)}
          data-test="email-over-quota-error"
          elevation={1}
        >
          <Typography>
            You have sent all the emails allowed in your monthly quota. You will be subject to overage fees
            for each email sent that exceeds your monthly quota. Please contact your account director if you
            need additional emails.
          </Typography>
        </Alert>
      )}
      {state.shouldShowEmailWarning && (
        <Alert
          severity="warning"
          onClose={() => state.setHasUserClosedEmailAlert(true)}
          data-test="email-warning-quota-error"
          elevation={1}
        >
          <Typography>
            You have less than {state.emailRemainingThreshold.toLocaleString()} emails remaining in your
            monthly quota. Please contact your account director if you need additional emails.
          </Typography>
        </Alert>
      )}
      {state.shouldShowTextError && (
        <Alert
          severity="error"
          onClose={() => state.setHasUserClosedTextAlert(true)}
          data-test="text-over-quota-error"
          elevation={1}
        >
          <Typography>
            You have sent all the text messages allowed in your monthly quota. You will be subject to overage
            fees for each text message sent that exceeds your monthly quota. Please contact your account
            director if you need additional text messages.
          </Typography>
        </Alert>
      )}
      {state.shouldShowTextWarning && (
        <Alert
          severity="warning"
          onClose={() => state.setHasUserClosedTextAlert(true)}
          data-test="text-warning-quota-error"
          elevation={1}
        >
          <Typography>
            You have less than {state.textRemainingThreshold.toLocaleString()} text messages remaining in your
            monthly quota. Please contact your account director if you need additional messages.
          </Typography>
        </Alert>
      )}
    </Stack>
  );
};
